import ImportExportSubMenuItems from '@popup/steem/pages/app-container/settings/advanced-settings/import-export-preferences/import-export-menu-items';
import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { MenuComponent } from 'src/common-ui/menu/menu.component';
const ImportExportPreferences = ({}) => {
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_IMPORT_EXPORT}-page`, className: "import-export-preferences-page" },
        React.createElement(MenuComponent, { title: "popup_html_import_export_settings", isBackButtonEnable: true, menuItems: ImportExportSubMenuItems })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const ImportExportPreferencesComponent = connector(ImportExportPreferences);
